module.exports = __webpack_public_path__ + "media/fonts/Cormorant-Medium-c5ec9a3af0d428ad7a43b8fbde3ac46c.woff2";